import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import './ButtonGroup.scss';

const { block, element } = bem('hook-form-button-group');

const ButtonGroup = props => {
  const { className, flush, children, divider = true, ...rest } = props;

  return (
    <div {...rest} className={block(className, { flush, divider })}>
      {React.Children.map(children, child =>
        React.isValidElement(child)
          ? React.cloneElement(child, {
              className: element('child', child.props.className),
            })
          : child
      )}
    </div>
  );
};

ButtonGroup.propTypes = {
  className: PropTypes.string,
  flush: PropTypes.bool,
  divider: PropTypes.bool,
  children: PropTypes.node,
};

export default ButtonGroup;
